export default __webpack_public_path__ + "static/media/Play_Button.a8b3423a.svg";